import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { CircularProgress } from "@ann/web-components";
import KnowledgePageView from "./pages/KnowledgeViewPage/KnowledgeViewPage";

// ✅ PERFORMANCE: Lazy load heavy components to reduce bundle size
const DocumentsView = lazy(() => {
  console.log('📦 Lazy loading DocumentsView...');
  return import("./pages/DocumentsView/DocumentsView");
});

const DrivesContent = lazy(() => {
  console.log('📦 Lazy loading DrivesView...');
  return import("./pages/DrivesView/DrivesView");
});

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
    <CircularProgress size="xl" />
  </div>
);

const KnowledgePage = () => {
  return (
    <Routes>
      <Route element={<KnowledgePageView />}>
        <Route index element={
          <Suspense fallback={<LoadingFallback />}>
            <DrivesContent />
          </Suspense>
        } />
        <Route path="documents" element={
          <Suspense fallback={<LoadingFallback />}>
            <DocumentsView />
          </Suspense>
        } />
        <Route path="drives" element={
          <Suspense fallback={<LoadingFallback />}>
            <DrivesContent />
          </Suspense>
        } />
      </Route>
    </Routes>
  );
};

export default KnowledgePage;
